import React, { FC } from 'react';
import Tooltip from 'rc-tooltip';

import SocialMediaShareButtons from '@buyside/components/presentation/SocialMediaShareButtons/socialMediaShareButtons';

import styles from './rankCardStyles.scss';

const RankCardShareButtons: FC<{ isCurrentUser: boolean; shareUrl: string; shareText: string }> = ({
  isCurrentUser,
  shareUrl,
  shareText
}) => {
  return (
    <Tooltip
      overlay={
        <div style={{ textAlign: 'center', maxWidth: '45ch' }}>
          {isCurrentUser ? (
            <>
              Share this ranking with your network. <strong>Note:</strong> We will not share ranking
              change information from the previous month
            </>
          ) : (
            'Share this ranking'
          )}
        </div>
      }
      placement="bottom"
    >
      <div className={styles.rankCardShareButtons}>
        <SocialMediaShareButtons.FacebookButton shareUrl={shareUrl} />
        <SocialMediaShareButtons.TwitterButton shareText={shareText} shareUrl={shareUrl} />
        <SocialMediaShareButtons.LinkedInButton shareText={shareText} shareUrl={shareUrl} />
      </div>
    </Tooltip>
  );
};

export default RankCardShareButtons;
